import { Modal } from "../Modal";
import { Upload, FileText } from "lucide-react";
import { BYTES_PER_KB } from "./officerUtils";

/**
 * Simple modal for browsing / uploading guard documents.
 * `docs` is an array; `onUpload` is a change handler for the file input.
 */
export function GuardDocsModal({ guard, docs, onUpload, onClose }) {
  return (
    <Modal onClose={onClose} title={`Documents · ${guard.name}`} testId="guard-docs-modal">
      <label className="flex items-center justify-center gap-2 border border-dashed border-[#3F3F46] hover:border-[#FF3B30] p-6 cursor-pointer transition-colors">
        <Upload className="size-4" />
        <span className="text-sm uppercase tracking-widest">Upload Certification</span>
        <input data-testid="upload-doc-input" type="file" className="hidden" onChange={onUpload} accept="image/*,application/pdf" />
      </label>
      <div className="mt-4 divide-y divide-[#27272A] border border-[#27272A]">
        {docs.map((d) => {
          const url = `${process.env.REACT_APP_BACKEND_URL}/api/files/${d.storage_path}`;
          return (
            <a key={d.id} href={url} target="_blank" rel="noreferrer" className="flex items-center gap-3 p-3 hover:bg-[#1c1c1e]">
              <FileText className="size-4 text-[#FF9F0A]" />
              <div className="flex-1 min-w-0">
                <div className="text-sm truncate">{d.original_filename}</div>
                <div className="text-xs text-zinc-500 font-mono">{(d.size / BYTES_PER_KB).toFixed(1)} KB · {new Date(d.created_at).toLocaleDateString()}</div>
              </div>
            </a>
          );
        })}
        {docs.length === 0 && <div className="p-8 text-center text-zinc-500 text-sm scanlines">No documents uploaded.</div>}
      </div>
    </Modal>
  );
}
